// src/App.js
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import ManageApps from "./pages/ManageApps";
import VentESApp from "./pages/VentESApp";
import AgentConnections from "./pages/AgentConnections";
import Actions from "./pages/Actions";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/manage-apps" element={
            <ProtectedRoute>
              <ManageApps />
            </ProtectedRoute>
          } />
          <Route path="/agent-connections" element={
            <ProtectedRoute>
              <AgentConnections />
            </ProtectedRoute>
          } />
          <Route path="/actions" element={
            <ProtectedRoute>
              <Actions />
            </ProtectedRoute>
          } />
          {/* VentES App Pages - Dynamic routing */}
          <Route path="/ventes-pet" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-crm" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-pay" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-bil" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-pos" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-rat" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-buy" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
          <Route path="/ventes-pem" element={
            <ProtectedRoute>
              <VentESApp />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
